import axios from '@/axios';
import qs from 'qs';

export class NotificationService {
  public static manageNotifications(params?: any): Promise<any> {
    params = params || {};
    return axios.post('/services/user/notifications', qs.stringify(params), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }
}
